import { render, staticRenderFns } from "./GroupAdd.vue?vue&type=template&id=e7e79e0c&scoped=true&"
import script from "./GroupAdd.vue?vue&type=script&lang=js&"
export * from "./GroupAdd.vue?vue&type=script&lang=js&"
import style0 from "./GroupAdd.vue?vue&type=style&index=0&id=e7e79e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e79e0c",
  null
  
)

export default component.exports